var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 21 21",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    fillRule: "evenodd",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1ca560",
    d: "M10.5 1.316a7.246 7.246 0 0 1 7.246 7.246c0 3.071-4.268 8.37-6.253 10.668-.258.299-.598.454-.993.454s-.735-.155-.993-.454c-1.985-2.298-6.253-7.597-6.253-10.668A7.246 7.246 0 0 1 10.5 1.316zm0 4.367a2.748 2.748 0 1 1 0 5.496 2.748 2.748 0 0 1 0-5.496z",
    opacity: 1,
    "data-original": "#00dc00",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map-marker.9c33d5f654f4d58210e846a04431412e.svg";
export { ForwardRef as ReactComponent };